module.exports = __webpack_public_path__ + "img/6-1-IMG_3001.8a651234.png";